import { Colors, Lightning, Log, Router, Utils, VideoPlayer } from '@lightningjs/sdk'
import PlayerBackButton from '../components/buttons/PlayerBackButton'
import PlayerHelper from '../lib/PlayerHelpers'

export default class LivePlayer extends Lightning.Component {
  static _template() {
    return {
      BG: { w: 1920, h: 1080, rect: true, color: Colors('dGgrey').get() },
      OverLay: {
        y: 400,
        alpha: 0,
        zIndex: 10,
        OverlayBG: { w: 1920, h: 1080, src: Utils.asset('/images/PlayerOverlay.png') },
        BackButton: { x: 1920 / 2, y: 880, w: 59, h: 59, mountX: 0.5, type: PlayerBackButton },
      },
    }
  }

  _init() {
    this._playerHelper = new PlayerHelper(this)
    this._playerHelper.initPlayer()
    VideoPlayer.size(1920, 1080)
    this._setState('Idle')
  }
  set data(v) {
    this._streamData = v
    this.active()
  }

  active() {
    VideoPlayer.open(this._streamData.streamUrl)
    // VideoPlayer.open("https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8");
    this._setState('Playing')
  }
  _inactive() {
    this.stage.gc()
  }

  _handleBack() {
    Log.info('LivePlayer:HandleBack')
    VideoPlayer.pause()

    VideoPlayer.clear()
    VideoPlayer.close()

    if (this._timeout) {
      clearTimeout(this._timeout)
    }

    Router.step(-1)
  }

  _getFocused() {
    return this
  }

  _interfaceTimeout(stallHide = false) {
    if (this._timeout) {
      clearTimeout(this._timeout)
    }

    if (stallHide === false) {
      this._timeout = setTimeout(() => {
        this._setState('Playing')
      }, 3500)
    }
  }

  $videoPlayerEvent(event) {
    switch (event) {
      case 'Playing':
        this.tag('BG').setSmooth('alpha', 0, { duration: 0.8, delay: 1.5 })
        break
      case 'Ended':
        this._handleBack()
        break
      case 'Clear':
      case 'Close':
        Log.info('videoPlayer close Event')
        // this._handleBack();
        break
    }
  }

  static _states() {
    return [
      class Idle extends this {
        $enter() {
          this.tag('OverLay').patch({
            y: 200,
            alpha: 0,
          })
        }
      },

      class Playing extends this {
        $enter() {
          this.tag('OverLay').patch({
            smooth: {
              y: [400, { duration: 0.5 }],
              alpha: [0, { duration: 0.5 }],
            },
          })
        }

        _handleKey() {
          this._setState('Overlay')
        }
      },

      class Overlay extends this {
        $enter() {
          this.tag('OverLay').patch({
            smooth: {
              y: [0, { duration: 0.5 }],
              alpha: [1, { duration: 0.5 }],
            },
          })

          this._interfaceTimeout()
        }

        _handleUp() {
          if (this._timeout) {
            clearTimeout(this._timeout)
          }
          this._setState('Playing')
        }

        _handleEnter() {
          this._handleBack()
        }
      },
    ]
  }
}
